<template>
  <form @submit.prevent="onRevision" class="col-sm-12">
    <FieldTextArea name="Revision" rules="required" v-model="form.revision" />
    <div class="row mt-2">
      <div class="col-sm-6">
        <button @click="$emit('close-modal')" type="button" class="btn btn-orange w-100">Back</button>
      </div>
      <div class="col-sm-6">
        <button type="submit" class="btn btn-border-orange w-100">Send</button>
      </div>
    </div>
  </form>
</template>

<script>
import FieldTextArea from '@/components/field/TextArea.vue';

export default {
  components: {
    FieldTextArea
  },
  data() {
    return {
      form: {
        revision: ''
      }
    }
  },
  methods: {
    async onRevision() {
      const valid = await this.$validator.validate()
      if (valid) {
        this.$emit('on-revision', this.form.revision)
      }
    },
  }
}
</script>
